define('OutSystems/ReactWidgets/Placeholder',["require", "exports", "tslib", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/ScrollExtensions", "OutSystems/ReactView/Widget", "OutSystems/ReactView/WidgetHelpers", "react"], function (require, exports, tslib_1, HtmlTags_1, ScrollExtensions, Widget_1, WidgetHelpers_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Placeholder = void 0;
    var Placeholder = (function (_super) {
        tslib_1.__extends(Placeholder, _super);
        function Placeholder() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Placeholder_1 = Placeholder;
        Placeholder.toHtmlAlign = function (align) {
            switch (align) {
                case 2:
                    return "center";
                case 1:
                    return "left";
                case 3:
                    return "right";
                default:
                    return undefined;
            }
        };
        Placeholder.prototype.hasOrWillHaveChildren = function (nextProps) {
            return true;
        };
        Placeholder.prototype.serializeCustomStateProperties = function () {
            return ScrollExtensions.serializeScrollProperties(this.getHTMLNode());
        };
        Placeholder.prototype.loadCustomStateProperties = function (customProperties) {
            ScrollExtensions.loadScrollProperties(this.getHTMLNode(), customProperties);
        };
        Placeholder.prototype.render = function () {
            var placeholderStyle = {
                textAlign: Placeholder_1.toHtmlAlign(this.props.align),
                minHeight: this.props.height,
                cursor: this.props.extendedEvents && this.props.extendedEvents.onClick ? "pointer" : undefined,
            };
            var placeholderAttributes = {
                className: this.props.style,
                style: placeholderStyle,
            };
            this.fillWithBuiltinProperties(placeholderAttributes);
            return React.createElement(HtmlTags_1.HtmlTags.div, placeholderAttributes, (0, WidgetHelpers_1.wrapElements)(this.props.content.render()));
        };
        var Placeholder_1;
        Placeholder = Placeholder_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Placeholder);
        return Placeholder;
    }(Widget_1.Widget));
    exports.Placeholder = Placeholder;
});
//# sourceMappingURL=Placeholder.js.map;
